import { Component } from '@verndale/core';
import { aliasToReal } from 'lodash/fp/_mapping';

class DesktopHeader extends Component {
  setupDefaults() {
    this.dom = {
      subItems: this.el.querySelectorAll('.has-submenu'),
      subItemWithSubmenu: this.el.querySelectorAll('.has-inner-submenu'),
      productsCard: this.el.querySelector('.desktop-header__card'),
      accordionBtns: this.el.querySelectorAll(
        '.desktop-header__nav__submenu-item__accordion-button'
      ),
      languageBtn: this.el.querySelector(
        '.desktop-header__nav__utility-nav-item--language'
      ),
      loginBtn: this.el.querySelector(
        '.desktop-header__nav__utility-nav-item--login'
      ),
      cartBtn: this.el.querySelector('.desktop-header__nav__utility-nav-item--cart'),
      cartContainer: document.querySelector(
        '.cart__container'
      ),
      closeCartBtn: document.querySelector(
        '.cart__item__close-button'
      ),
      keepBrowsingBtn: document.querySelector('.cart__view-basket-button--keep-browsing')
    };
  }

  addListeners() {
    this.dom.subItems.forEach(item => {
      item.addEventListener('mouseenter', this.toggleSubMenu.bind(this));
      item.addEventListener('mouseleave', this.toggleSubMenu.bind(this));
    });

    this.dom.subItemWithSubmenu.forEach(item => {
      item.addEventListener('mouseenter', this.toggleInnerMenu.bind(this));
      item.addEventListener('mouseleave', this.toggleInnerMenu.bind(this));
    });

    this.dom.accordionBtns.forEach(btn => {
      btn.addEventListener('click', this.toggleAccordion.bind(this));
    });

    this.dom.languageBtn.addEventListener(
      'click',
      this.toggleLanguage.bind(this)
    );

    if (this.dom.loginBtn) {
      this.dom.loginBtn.addEventListener('click', this.toggleLogin.bind(this));
    }

    this.dom.cartBtn.addEventListener('click', this.toggleCart.bind(this));
    this.dom.closeCartBtn.addEventListener('click', this.closeCartNav.bind(this));
    this.dom.keepBrowsingBtn.addEventListener('click', this.closeCartNav.bind(this));
  }

  closeCartNav() {
    this.dom.cartContainer.setAttribute('hidden', true);
    this.dom.cartBtn.classList.remove('is-active');
    document.body.style.overflow = 'auto';
  }

  toggleCart() {
    this.dom.cartBtn.classList.toggle('is-active');

    if (this.dom.cartContainer.hidden) {
      this.dom.cartContainer.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    } else {
      this.dom.cartContainer.setAttribute('hidden', true);
      document.body.style.overflow = 'auto';
    }
  }

  closeAllAccordions(currentBtn) {
    this.dom.accordionBtns.forEach(btn => {
      if (btn !== currentBtn) {
        const ariaControls = btn.getAttribute('aria-controls');
        const accordionContent = document.getElementById(ariaControls);
        const minusIcon = btn.querySelector('.minus-icon');
        const plusIcon = btn.querySelector('.plus-icon');

        accordionContent.setAttribute('hidden', true);
        minusIcon.setAttribute('hidden', true);
        plusIcon.removeAttribute('hidden');
      }
    });
  }

  hideOnClickOutside(element, anchor, arrowIcon) {
    const outsideClickListener = event => {
      if (element !== event.target && !element.contains(event.target)) {
        const ariaControls = anchor.getAttribute('aria-controls');
        const submenu = document.getElementById(ariaControls);

        if (!submenu.contains(event.target)) {
          anchor.classList.remove('is-active');
          submenu.hidden = true;
          if (arrowIcon) {
            arrowIcon.style.transform = 'rotate(0deg)';
          }
          removeClickListener();
        }

      }
    };

    const removeClickListener = () => {
      document.removeEventListener('click', outsideClickListener);
    };

    document.addEventListener('click', outsideClickListener);
  }

  toggleLogin(e) {
    const anchor = e.target.closest('a');
    if (!anchor) return;
    const ariaControls = anchor.getAttribute('aria-controls');
    const loginContent = document.getElementById(ariaControls);
    this.hideOnClickOutside(e.target.parentElement, anchor);

    if (!loginContent) return;
    if (loginContent.hidden) {
      loginContent.removeAttribute('hidden');
      anchor.classList.add('is-active');
    } else {
      loginContent.setAttribute('hidden', true);
      anchor.classList.remove('is-active');
    }
  }

  toggleLanguage(e) {
    const anchor = e.target.closest('a');
    if (!anchor) return;
    const ariaControls = anchor.getAttribute('aria-controls');
    const languageContent = document.getElementById(ariaControls);
    const arrowIcon = anchor.querySelector('.down-icon');
    this.hideOnClickOutside(e.target.parentElement, anchor, arrowIcon);

    if (!languageContent) return;
    if (languageContent.hidden) {
      languageContent.removeAttribute('hidden');
      arrowIcon.style.transform = 'rotate(180deg)';
      anchor.classList.add('is-active');
    } else {
      languageContent.setAttribute('hidden', true);
      arrowIcon.style.transform = 'rotate(0deg)';
      anchor.classList.remove('is-active');
    }
  }

  toggleAccordion(el) {
    const button = el.target.closest('button');
    if (!button) return;
    const ariaControls = button.getAttribute('aria-controls');
    const accordionContent = document.getElementById(ariaControls);
    const minusIcon = button.querySelector('.minus-icon');
    const plusIcon = button.querySelector('.plus-icon');

    this.closeAllAccordions(button);

    if (accordionContent.hidden) {
      accordionContent.removeAttribute('hidden');
      minusIcon.removeAttribute('hidden');
      plusIcon.setAttribute('hidden', true);
    } else {
      accordionContent.setAttribute('hidden', true);
      minusIcon.setAttribute('hidden', true);
      plusIcon.removeAttribute('hidden');
    }
  }

  toggleInnerMenu(e) {
    const li = e.target;
    const parent = li.parentElement;
    const anchor = li.querySelector('.desktop-header__nav-link');
    const ariaControls = anchor.getAttribute('aria-controls');
    const submenu = document.getElementById(ariaControls);
    const list = submenu.querySelector('.desktop-header__nav-list');

    if (e.type === 'mouseenter' && submenu) {
      anchor.classList.add('is-active');
      submenu.style.top = 0;
      submenu.removeAttribute('hidden');
      this.calculatePosition(parent.parentElement, submenu);
      if (list.offsetHeight > parent.offsetHeight)
        parent.style.height = `${list.offsetHeight}px`;
    }

    if (e.type === 'mouseleave' && submenu) {
      anchor.classList.remove('is-active');
      submenu.setAttribute('hidden', true);
      submenu.removeAttribute('style');
      parent.removeAttribute('style');
      parent.parentElement.removeAttribute('style');
    }
  }

  toggleSubMenu(e) {
    const anchor = e.target.querySelector('.desktop-header__nav-link');
    const ariaControls = anchor.getAttribute('aria-controls');
    const submenu = document.getElementById(ariaControls);

    if (e.type === 'mouseenter' && submenu) {
      anchor.classList.add('is-active');
      submenu.removeAttribute('hidden');
      this.calculatePosition(submenu);
    }

    if (e.type === 'mouseleave' && submenu) {
      anchor.classList.remove('is-active');
      submenu.setAttribute('hidden', true);
    }
  }

  calculatePosition(element, innerMenu) {
    if (innerMenu) {
      element.style.width = `${element.offsetWidth + innerMenu.offsetWidth}px`;
    }

    const mainWrapper = document.querySelector('.main-header');

    const elementPosition = element.getBoundingClientRect();
    const wrapperPosition = mainWrapper.getBoundingClientRect();
    const elementWidth = element.offsetWidth;
    const wrapperWidth = mainWrapper.offsetWidth;
    const elementRight = elementPosition.right;
    const elementLeft = elementPosition.left;

    if (elementRight > wrapperPosition.left + wrapperWidth) {
      element.classList.add('desktop-header__submenu--right');
    } else if (elementLeft < elementWidth) {
      element.classList.add('desktop-header__submenu--left');
    }
  }
}

export default DesktopHeader;
